import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'real'})
export class RealPipe implements PipeTransform {
  transform(value: number): string {
    value = Math.round((value * 100.0));
    value = value / 100.0;
    let moneyStr = value.toFixed(2).toString();
    moneyStr = "R$ " + moneyStr.replace(".", ",");
    return moneyStr;
  }
}


// WEBPACK FOOTER //
// ./src/pipe/money.ts